import React from 'react';

// Styles & Assets
import styles from './CheckboxButton.module.css';

// Hooks
import { useRef } from 'react';

const CheckboxButton: React.FC<{
    label: string,
    checked?: boolean, // if undefined checkox is uncontrolled
    defaultChecked?: boolean // default checked. only works if checkbox is uncontrolled
    size?: number
    disabled?: boolean
    onClick: (checked: boolean) => void,
}> = ({ label, checked, defaultChecked, size, disabled, onClick }) => {

    const handleOnClick = () => onClick(!checked);

    const handleClickUncontrolled = () => {
        if (uncontrolledRef.current) {
            uncontrolledRef.current.checked = !uncontrolledRef.current.checked;
            onClick(uncontrolledRef.current.checked);
        }
    };

    const handleClickInput = (e: React.MouseEvent<HTMLInputElement>) => {
        e.stopPropagation();
        if (uncontrolledRef.current) onClick(uncontrolledRef.current.checked);
    };

    const uncontrolledRef = useRef<HTMLInputElement>(null);

    return (
        <>
            {checked !== undefined ?
                <button className={styles.button} onClick={handleOnClick} disabled={disabled}>
                    <input
                        className={styles.checkbox}
                        style={size ? { height: size + 'px', width: size + 'px' } : undefined}
                        type='checkbox'
                        checked={checked}
                        onChange={() => {/* */ }} >
                    </input>
                    <span className={styles.label}>{label}</span>
                </button>
                :
                <button className={styles.uncontrolledCheckbox} onClick={handleClickUncontrolled}>
                    <span>{label}</span>
                    <input
                        ref={uncontrolledRef}
                        className={styles.checkbox}
                        style={size ? { height: size + 'px', width: size + 'px' } : undefined}
                        type='checkbox'
                        defaultChecked={defaultChecked}
                        onClick={handleClickInput}
                    >
                    </input>
                </button>
            }
        </>
    );
};

export default CheckboxButton;